import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=5a8f2de4&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=5a8f2de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f2de4",
  null
  
)

export default component.exports